import React from 'react';
import { Box, Toolbar } from '@mui/material';
import Sidebar from '../panel/Sidebar';
import Footer from '../panel/Footer';

const drawerWidth = 240;

const DashboardLayout = ({ children, user }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Toolbar />
          {children}
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default DashboardLayout;
